export default{
    data(){
        return {
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtZGVjaGVjaGkiLCJpYXQiOjE3NTk3OTQ1ODEsImV4cCI6MTc1OTg4MDk4MX0.FRoSkNszl6bRSB1clzogz1cjX0CigqW9jFcBjmHhhKI',
            result: []
        }
    },
    async validaToken(){

    },
    async get(rota){
        var result
        var config = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtZGVjaGVjaGkiLCJpYXQiOjE3NjEwMDY3NDYsImV4cCI6MTc2MzU5ODc0Nn0.bssRPHWD7Y_J-lQXCA5EZRDWotLBwhm3rFI131IgIcw`,
                'Content-Type': 'application/json'
            }
        }
        var request = new Request(`https://ifood-api.cwsweb.com.br/v1/${rota}`, config)
        await fetch(request)
        .then(res => res.json())
        .then(data => result = data)
        .catch(err => console.log(err))
        return result
    },

    async post(rota, json){
        var result
        var jsonStringfy = JSON.stringify(json)
        var config = {
            method: 'POST',
            body: jsonStringfy,
            headers: {
                'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtZGVjaGVjaGkiLCJpYXQiOjE3NjEwMDY3NDYsImV4cCI6MTc2MzU5ODc0Nn0.bssRPHWD7Y_J-lQXCA5EZRDWotLBwhm3rFI131IgIcw`,
                'Content-Type': 'application/json'
            }
        }
        var request = new Request(`https://ifood-api.cwsweb.com.br/v1/${rota}`, config)
        await fetch(request)
        .then(res => res.json())
        .then(data => result = data)
        .catch(err => console.log(err))
        return result
    },

    async put(rota, json){
        var result
        var jsonStringfy = JSON.stringify(json)
        var config = {
            method: 'PUT',
            body: jsonStringfy,
            headers: {
                'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtZGVjaGVjaGkiLCJpYXQiOjE3NjEwMDY3NDYsImV4cCI6MTc2MzU5ODc0Nn0.bssRPHWD7Y_J-lQXCA5EZRDWotLBwhm3rFI131IgIcw`,
                'Content-Type': 'application/json'
            }
        }
        var request = new Request(`https://ifood-api.cwsweb.com.br/v1/${rota}`, config)
        await fetch(request)
        .then(res => res.json())
        .then(data => result = data)
        .catch(err => console.log(err))
        return result
    },

    async sendFile(rota, arquivo, nomeArquivo) {
        let result;
    
        // Cria o FormData e adiciona o arquivo
        const formData = new FormData();
        formData.append('agendamento', arquivo, nomeArquivo);
    
        // Monta a configuração da requisição
        const config = {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtZGVjaGVjaGkiLCJpYXQiOjE3NjEwMDY3NDYsImV4cCI6MTc2MzU5ODc0Nn0.bssRPHWD7Y_J-lQXCA5EZRDWotLBwhm3rFI131IgIcw`
            }
        };
    
        try {
            const request = new Request(`http://localhost:3000/v1/${rota}`, config);
            const response = await fetch(request);
            result = await response.json();
        } catch (err) {
            console.error("Erro ao enviar arquivo:", err);
            result = { error: true, message: err.message };
        }
    
        return result;
    }    
}